<template>
    <div
        v-show="showList()"
        :id="controlId"
    >
        <p class='label-text'
           v-if="labelText"
        >
           {{ labelText }}
        </p>
        <ul class="lni-u-reset-list">
             <li
                v-for="errorNode in errors"
                v-bind:key="getErrorKey(errorNode)"
                class="lni-u-pt2"
             >
                <x-error
                    :data-global-text="getErrorText(errorNode)"
                    :data-global="true"
                    :data-id="getErrorKey(errorNode)"
                />
            </li>
        </ul>
    </div>
</template>


<script>
import framework from '../../framework';

/**
 *  The x-error-list component.
 *  @module components/x-error-list
 */


/**
 * The x-error-list
 */
export default {
    name: 'x-error-list',
    mixins: [
        framework.mixins.abstractInput,
    ],
    computed: {
        /**
        * The text for the label.
        * @returns {string} label text.
        */
        labelText() {
            return this.getAttribute('labelText', '');
        },
    },
    methods: {
        /**
         * Whether or not to show the error container.
         * @returns {boolean} Whether or not to show the error container.
         */
        showList() {
            let path = this.$router.history.current.path;
            let showErrors = this.$store.getters.showRouteErrors(path);
            let hasErrors = this.nodeManifest.children.length > 0;
            return showErrors && hasErrors;
        },
        getErrorText(errorNode) {
            return errorNode.errors[0].globalText;
        },
        getErrorKey(errorNode) {
            let error = errorNode.errors[0];
            if (error.parentId) {
                return `${error.parentId}_${error.id}`;
            }

            return error.id;
        },
    },
};
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// source/components/x-error-list/x-error-list.vue